import React from 'react'
import Person4Icon from '@mui/icons-material/Person4';
import { useState } from 'react';
import AgreeNachBillItemAllForm from './AgreeNachBillItemAllForm';
import SupplyBillAgreeIco from '../../../../SupplyBillAgreeIco';
import MyModal from '../../../../../../../../UI/modal/MyModal';
import { Tooltip } from '@mui/material';

const AgreeNachAllButton = ({ supplyBillId, supplyBillItems }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        {/* <SupplyBillAgreeIco
            onClick={e => setOpen(true)}
            text={'Погодження начальником постачання'}
            ico={<Person4Icon />}
            // value={supplyBillItem.isAgreeSupplyLeader}
        /> */}
        <Tooltip 
            title={'Погодження начальником постачання'}
            onClick={e => setOpen(true)}
        >
            <Person4Icon />
        </Tooltip>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={'Погодження'}
            disableClickOutside={true}
            content={
                <AgreeNachBillItemAllForm
                    supplyBillId={supplyBillId}
                    supplyBillItems={supplyBillItems}
                    setOpen={setOpen}
                />
            }
        />
    </>
  )
}

export default AgreeNachAllButton